export default {
  data() {
    return {
      geoLocationOptions: {
        watchID: null
      },

      defaultOptions: {
        enableHighAccuracy: false,
        maximumAge        : 15000,
        timeout           : 60000
      }
    }
  },

  methods: {
    getGeoLocation(options = this.defaultOptions, forceReject = false) {
      return new Promise((resolve, reject) => {
        if (forceReject) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('reject forced for testing purposes')
          return
        }
        if (!this.isGeoLocationAvailable()) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('no browser support')
        } else {
          window.navigator.geolocation.getCurrentPosition(
            position => {
              resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude
              })
            },
            (e) => {
              reject(e.message)
            },
            options
          )
        }
      })
    },

    watchGeoLocation(options = this.defaultOptions, forceReject = false) {
      return new Promise((resolve, reject) => {
        if (forceReject) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('reject forced for testing purposes')
          return
        }
        if (!this.isGeoLocationAvailable()) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('no browser support')
        } else {
          this.geoLocationOptions.watchID = window.navigator.geolocation.watchPosition(
            position => {
              resolve({
                lat             : position.coords.latitude,
                lng             : position.coords.longitude,
                altitude        : position.coords.altitude,
                altitudeAccuracy: position.coords.altitudeAccuracy,
                accuracy        : position.coords.accuracy,
                heading         : position.coords.heading,
                speed           : position.coords.speed
              })
            },
            (e) => {
              // alert(e.message)
              reject(e.message)
            },
            options
          )
        }
      })
    },

    clearGeoLocation() {
      return new Promise((resolve, reject) => {
        if (!this.isGeoLocationAvailable()) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('no browser support')
        } else {
          if (this.geoLocationOptions.watchID) {
            resolve(window.navigator.geolocation.clearWatch(this.geoLocationOptions.watchID))
          } else {
            resolve(true)
          }
        }
      })
    },

    isGeoLocationAvailable() {
      return 'geolocation' in window?.navigator
    }
  }

}
